/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgSearchSmaller24(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='#000'
        fillRule='evenodd'
        d='M7.5 11.464a3.964 3.964 0 117.927 0 3.964 3.964 0 01-7.927 0zM11.464 6a5.464 5.464 0 103.296 9.821l3.244 3.243 1.06-1.06-3.243-3.244A5.464 5.464 0 0011.464 6z'
      />
    </svg>
  );
}

export default SvgSearchSmaller24;
